module.exports = __webpack_public_path__ + "img/7@3x.a55f3f59.png";